import styled from 'styled-components'

export const GradientText = styled.h1`
margin: 0;
text-transform: uppercase;
font-size: 4rem;
line-height: 1.1em;
`;
